<template>
  <div class="massLoss-list" v-loading="loading">
    <div class="nav">
      <el-form :model="searchForm" label-width="110px" :inline="true" class="demo-form-inline flex1">
        <el-form-item label="运单编号：">
          <el-input v-model="searchForm.waybillNo" size="mini" placeholder="请输入运单编号"></el-input>
        </el-form-item>
        <el-form-item label="车架号：">
          <el-input
            v-model="searchForm.frameNumber"
            size="mini"
            placeholder="请输入车架号"
            @paste.native.capture.prevent="
              value => {
                return searchCopyFormat(value, 'frameNumber');
              }
            "></el-input>
        </el-form-item>
        <el-form-item label="委托商：">
          <el-input v-model="searchForm.consignorName" size="mini" placeholder="请输入委托商名称"></el-input>
        </el-form-item>
        <el-form-item label="供应商：">
          <el-input v-model="searchForm.supplierName" size="mini" placeholder="请输入供应商名称"></el-input>
        </el-form-item>
        <el-form-item label="台账月：">
          <el-input
            v-model="searchForm.standingBookMonthStr"
            size="mini"
            placeholder="请输入台账月"
            @paste.native.capture.prevent="
              value => {
                return searchCopyFormat(value, 'standingBookMonthStr');
              }
            " />
        </el-form-item>
        <el-form-item label="品牌：">
          <el-input v-model="searchForm.brandName" size="mini" placeholder="请输入品牌" />
        </el-form-item>
        <el-form-item label="是否生成台账：">
          <el-select v-model="searchForm.isAccount" filterable size="mini" placeholder="请选择是否生成台账">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否提交调账：">
          <el-select v-model="searchForm.isAdjust" filterable size="mini" placeholder="请选择是否提交调账">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用类型：">
          <el-select v-model="searchForm.typeStrs" multiple clearable filterable size="mini" placeholder="请选择费用类型">
            <el-option v-for="item in priceType" :key="item.value" :label="item.lable" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有无含税金额：">
          <el-select v-model="searchForm.isContactPrice" filterable size="mini" placeholder="请选择有无含税金额">
            <el-option label="全部" value=""></el-option>
            <el-option label="有" :value="1"></el-option>
            <el-option label="无" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否计算出金额：" label-width="130px">
          <el-select v-model="searchForm.taxPriceDiffer" filterable size="mini" placeholder="请选择有无含税金额">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算方式：">
          <el-select v-model="searchForm.settType" filterable size="mini" placeholder="请选择结算方式">
            <el-option v-for="item in settTypeOption" :key="item.label" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="实际结算方式：">
          <el-select v-model="searchForm.actualSettType" filterable size="mini" placeholder="请选择有无含税金额">
            <el-option v-for="item in actualSettTypeOption" :key="item.label" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="对账单编号：">
          <el-input v-model="searchForm.settNo" size="mini" placeholder="请输入对账单编号"></el-input>
        </el-form-item>
        <el-form-item label="提交台账批次：">
          <el-input v-model="searchForm.TJTZBatch" size="mini" placeholder="请输入对账单编号"></el-input>
        </el-form-item>
        <el-form-item label="调整台账批次：">
          <el-input v-model="searchForm.TZTZBatch" size="mini" placeholder="请输入对账单编号"></el-input>
        </el-form-item>
        <el-form-item label="计划时间：">
          <el-date-picker v-model="searchForm.dealer[0]" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange1" type="date" placeholder="开始日期" />
          <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
          <el-date-picker v-model="searchForm.dealer[1]" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange1" type="date" placeholder="结束日期" />
        </el-form-item>
        <el-form-item label="交车时间：">
          <el-date-picker v-model="searchForm.delivery[0]" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange2" type="date" placeholder="开始日期" />
          <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
          <el-date-picker v-model="searchForm.delivery[1]" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange2" type="date" placeholder="结束日期" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <!-- start -->
          <el-button size="small" type="primary" @click="priceRefreshBtn">一次暂估价格刷新</el-button>
          <el-button size="small" type="primary" @click="secondEstimatedPriceRefreshBtn">二次暂估价格刷新</el-button>
          <el-button size="small" type="primary" @click="tripleEstimatedPriceRefresh">三次暂估价格刷新</el-button>
          <el-button size="small" type="primary" @click="generateAccount">一次暂估生成台账</el-button>
          <el-button size="small" type="primary" @click="secondaryEstimationGenerationLedger">二次暂估生成台账</el-button>
          <el-button size="small" type="primary" @click="tripleEstimationGenerationLedger">三次暂估生成台账</el-button>
          <el-button size="small" type="primary" @click="refreshActualSettlementPrice">实际结算价格刷新</el-button>
          <el-button size="small" type="primary" @click="submitReconciliation">提交调账</el-button>
          <el-button size="small" type="primary" @click="reconciliationAdjustmentPriceRefresh">对账调整价格刷新</el-button>
          <el-button size="small" type="primary" @click="reconciliationAdjustmentGenerationLedger">对账调整生成台账</el-button>
          <!-- end -->
<!--          <el-button size='small' type='primary' @click='refreshAccount'>刷新台账</el-button>-->
          <!--          <el-button size='small' type='primary' @click='correctionAndAdjustment'>纠错调账
          </el-button>-->
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span style="color: red">{{ message }}</span>
        <span @click="exportData">导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table ref="registerTable" v-loading="tableLoading" :data="tableData" style="width: 100%" border :header-cell-style="headerCellStyle" :span-method="objectSpanMethod" @selection-change="selectionDataChange" @row-click="handleRowClick" :row-style="rowStyle">
          <el-table-column type="selection" align="center" min-width="80px" />
          <el-table-column prop="consignorName" label="委托商" align="center" min-width="240px" />
          <el-table-column prop="standingBookMonth" label="台账月" align="center" min-width="100px" />
          <el-table-column prop="waybillNo" label="运单编号" align="center" min-width="120px" />
          <el-table-column prop="frameNumber" label="车架号" align="center" min-width="200px" />
          <el-table-column prop="brandName" label="品牌" align="center" min-width="100px" />
          <el-table-column prop="modelName" label="型号" align="center" min-width="100px" />
          <el-table-column prop="departurePlace" label="起始地" align="center" min-width="180px" />
          <el-table-column prop="departurePort" label="起运港" align="center" min-width="100px" />
          <el-table-column prop="arrivePort" label="交车港" align="center" min-width="100px" />
          <el-table-column prop="arrivePlace" label="交车地" align="center" min-width="180px" />
          <el-table-column prop="plannedDate" label="计划时间" align="center" min-width="100px" />
          <el-table-column prop="deliveryDate1" label="交车时间" align="center" min-width="100px" />
          <el-table-column prop="transType" label="运输方式" align="center" min-width="100px">
            <template slot-scope="scope">
              {{ scope.row.transType === 1 ? '公路' : scope.row.transType === 2 ? '水路' : '水陆联运' }}
            </template>
          </el-table-column>
          <el-table-column prop="oilPrice" label="油价联动金额" align="center" min-width="100px" />
          <el-table-column prop="taxContractPrice" label="一次暂估价" align="center" min-width="100px" />
          <el-table-column prop="taxContractPriceDif2" label="二次暂估差价" align="center" min-width="100px" />
          <el-table-column prop="taxContractPriceDif3" label="三次暂估差价" align="center" min-width="100px" />
          <el-table-column prop="taxAdjustPrice" label="对账调整差价" align="center" min-width="100px" />
          <el-table-column prop="taxGlPrice" label="含税公路运费" align="center" min-width="100px" />
          <el-table-column prop="taxSlPrice" label="含税水路运费" align="center" min-width="100px" />
          <el-table-column prop="taxMdglPrice" label="含税末端公路运费" align="center" min-width="140px" />
          <el-table-column prop="freightSettNo" label="收入对账单编号" align="center" min-width="120px" />
          <el-table-column prop="ryjsbatch" label="燃油结算批次" align="center" min-width="120px" />
          <el-table-column prop="taxActualPrice" label="实际结算含税运费" align="center" min-width="140px" />
          <el-table-column prop="actualSettType" label="实际结算方式" align="center" min-width="100px" />
          <el-table-column prop="taxPriceDiffer" label="运费差额" align="center" min-width="100px" />
          <el-table-column prop="taxZxPrice" label="含税装卸费" align="center" min-width="100px" />
          <el-table-column prop="operationSettNo" label="装卸费对账单编号" align="center" min-width="130px" />
          <el-table-column prop="zxActualPrice" label="实际结算含税装卸费" align="center" min-width="140px" />
          <el-table-column prop="zxPriceDiffer" label="装卸费差额" align="center" min-width="100px" />
          <el-table-column prop="TZTZBatch" label="收入调账批次" align="center" min-width="100px"> </el-table-column>
          <el-table-column label="收入是否冲抵" align="center" min-width="100px">
            <template slot-scope="scope">
              {{ scope.row.isOffset2 == 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="tjtzbatch4" label="收入对账调整台账批次" align="center" min-width="180px" />
          <el-table-column prop="supplierName" label="供应商" align="center" min-width="180px" />
          <el-table-column prop="departurePlacePort" label="起始地" align="center" min-width="180px" />
          <el-table-column prop="arrivePlacePort" label="交车地" align="center" min-width="180px" />
          <el-table-column prop="plannedDate2" label="计划/作业时间" align="center" min-width="110px" />
          <el-table-column prop="dispatchDate2" label="发运日期" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.dispatchDate2 | formatTime }}</template>
          </el-table-column>
          <el-table-column prop="deliveryDate2" label="交车时间" align="center" min-width="100px">
            <template slot-scope="scope">
              {{ scope.row.plannedDate2 ? scope.row.plannedDate2.substring(0, 10) : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="type" label="费用类型" align="center" min-width="100px">
            <template slot-scope="scope">
              {{ getType(scope.row.type2) }}
            </template>
          </el-table-column>
          <el-table-column prop="taxRate2" label="税率" align="center" min-width="100px" />
          <el-table-column prop="taxContractPrice2" label="一次暂估价" align="center" min-width="100px" />
          <el-table-column prop="taxContractPriceDifZc2" label="二次暂估差价" align="center" min-width="100px" />
          <el-table-column prop="taxContractPriceDifZc3" label="三次暂估差价" align="center" min-width="100px" />
          <el-table-column prop="taxAdjustPriceZc" label="对账调整差价" align="center" min-width="100px" />
          <el-table-column prop="paySettNo" label="支出对账单编号" align="center" min-width="180px" />
          <el-table-column prop="taxActualPrice2" label="实际结算含税金额" align="center" min-width="130px" />
          <el-table-column label="实际结算方式" align="center" min-width="100px">
            <template slot-scope="scope">
              {{ scope.row.actualSettType2 === null ? '未结算' : scope.row.actualSettType2 }}
            </template>
          </el-table-column>
          <el-table-column prop="taxPriceDiffer2" label="差额" align="center" min-width="100px" />
          <el-table-column prop="isAccount" label="是否生成台账" align="center" min-width="100px">
            <template slot-scope="scope">
              {{ scope.row.isAccount ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="TZTZBatch2" label="支出调账批次" align="center" min-width="100px"> </el-table-column>
          <el-table-column prop="ledgeNumber" label="一次暂估台账批次" align="center" min-width="100px" />
          <el-table-column prop="tjtzbatch2" label="二次暂估台账批次" align="center" min-width="100px" />
          <el-table-column prop="tjtzbatch3" label="三次暂估台账批次" align="center" min-width="100px" />
          <el-table-column prop="tjtzbatchZc4" label="支出对账调整台账批次" align="center" min-width="100px" />
          <!--          <el-table-column prop='TZTZBatch' label='调整台账批次' align='center'
                           min-width='100px'/>-->
          <el-table-column prop="ryjsbatch2" label="燃油结算批次" align="center" min-width="100px" />
          <el-table-column label="支出是否冲抵" align="center" min-width="100px">
            <template slot-scope="scope">
              {{ scope.row.isOffset == 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px" align="center">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="submitBtn(scope.row)">提交调账 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.rows" />
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="400px" center top="10vh" @close="dialogClose" :close-on-click-modal="false">
      <div class="btnContainer">
        <el-button size="medium" class="searchBtn" @click="disburseClick">支出 </el-button>
        <el-button size="medium" class="resetBtn" @click="incomeClick">收入</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogAccoutTitle" :visible.sync="dialogAccoutVisible" width="450px" center top="10vh" @close="dialogAccoutClose" :close-on-click-modal="false">
      <div class="btnContainer">
        <el-radio-group v-model="radio">
          <el-radio label="0">收入</el-radio>
          <el-radio label="1">支出</el-radio>
          <!--          <el-radio label="2">收入/支出</el-radio>-->
        </el-radio-group>
      </div>
      <div class="btnContainer">
        <el-button size="medium" class="searchBtn" @click="submit" :loading="submitLoading">确认</el-button>
        <el-button size="medium" class="resetBtn" @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <account-and-reconciliation ref="accountAndReconciliation" @getTableData="getTableData" />
    <correction-and-adjustment ref="correctionAndAdjustmentRef" />
  </div>
</template>

<script>
  import AccountAndReconciliation from '@/views/settle/accountManagement/accountDetails/components/accountAndReconciliation';
  import { generateAccount, generateAccountByDifference, generateAccountByDifferenceBatch, getAccountList, getPriceRefresh, refreshAccountList, refreshActualSettlementPrice, updateSettlementAccount3, updateSettlementAccount4, generateAccount1, adjustDifPrice, generateAccountByDifferenceBatch2, generateAccount2 } from '@/service/account';
  import { formatTime, getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import CorrectionAndAdjustment from '@/views/settle/accountManagement/accountDetails/components/correctionAndAdjustment.vue';

  export default {
    name: 'accountDetails',
    components: { CorrectionAndAdjustment, AccountAndReconciliation },
    data() {
      return {
        flag1: '',
        loading: false,
        submitLoading: false,
        addForm: {
          id: '',
          parentId: '',
        },
        searchForm: {
          taxPriceDiffer: '',
          actualSettType: '',
          TZTZBatch: '',
          TJTZBatch: '',
          id: '',
          parentId: '',
          waybillNo: '',
          frameNumber: '',
          consignorName: '',
          supplierName: '',
          standingBookMonthStr: '',
          isAccount: '',
          isAdjust: '',
          brandName: '',
          settType: '',
          typeStrs: [],
          isContactPrice: '',
          dealer: ['', ''], // 计划日期
          delivery: ['', ''], // 交车日期
          settNo: '',
          type: '',
          page: 1,
          rows: 10,
        },
        message: '',
        settTypeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '合同价',
          },
          {
            value: 2,
            label: '预结算价',
          },
        ],
        actualSettTypeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: '合同价',
            label: '合同价',
          },
          {
            value: '预结算价',
            label: '预结算价',
          },
          {
            value: '未结算',
            label: '未结算',
          },
        ],
        priceType: [
          { value: '0', lable: '收入' },
          { value: '1', lable: '公路运费' },
          { value: '2', lable: '水路运费' },
          { value: '3', lable: '装船费' },
          { value: '4', lable: '卸船费' },
          { value: '5', lable: '过驳费' },
          { value: '6', lable: '转船费' },
          { value: '7', lable: '堆存费' },
          { value: '8', lable: '提车费' },
        ],
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        total: 0,
        dialogTitle: '提交对账',
        dialogVisible: false,
        dialogAccoutTitle: '提交对账',
        dialogAccoutVisible: false,
        radio: '',
        checkTableData: [],
      };
    },
    filters:{
      formatTime(val) {
        if (val) {
          return formatTime(val, 'yyyy-mm-dd ');
        }
        return '';
      },
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      // this.searchBtn();
    },
    methods: {
      async reconciliationAdjustmentPriceRefresh() {
        if (!this.searchForm.typeStrs) return this.$message.warning('费用类型不能为空');
        this.loading = true;
        let { data, status, message } = await adjustDifPrice({
          ...this.searchForm,
        });
        this.loading = false;
        if (status !== 0) return this.$message.warning(message);
        // 表格刷新
        await this.getTableData();
      },
      async tripleEstimationGenerationLedger() {
        let flag = false;
        for (let searchFormKey in this.searchForm) {
          if (searchFormKey === 'page' || searchFormKey === 'rows') continue;
          if (this.searchForm[searchFormKey] !== '') {
            flag = true;
          }
        }
        if (!flag) return this.$message.warning('请输入查询条件后生成台账！');
        this.$confirm('确认是否生成台账？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          this.loading = true;
          const { status, message } = await generateAccount2({
            ...this.searchForm,
            carList: this.searchForm.frameNumber.length > 0 ? this.searchForm.frameNumber.split(',') : [],
            deliveryDateStart: this.searchForm.delivery[0],
            deliveryDateEnd: this.searchForm.delivery[1],
          });
          this.loading = false;
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.searchBtn();
        });
      },
      async secondaryEstimationGenerationLedger() {
        let flag = false;
        for (let searchFormKey in this.searchForm) {
          if (searchFormKey === 'page' || searchFormKey === 'rows') continue;
          if (this.searchForm[searchFormKey] !== '') {
            flag = true;
          }
        }
        if (!flag) return this.$message.warning('请输入查询条件后生成台账！');
        this.$confirm('确认是否生成台账？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          this.loading = true;
          const { status, message } = await generateAccount1({
            ...this.searchForm,
            carList: this.searchForm.frameNumber.length > 0 ? this.searchForm.frameNumber.split(',') : [],
            deliveryDateStart: this.searchForm.delivery[0],
            deliveryDateEnd: this.searchForm.delivery[1],
          });
          this.loading = false;
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.searchBtn();
        });
      },
      async tripleEstimatedPriceRefresh() {
        if (!this.searchForm.typeStrs) return this.$message.warning('费用类型不能为空');
        this.loading = true;
        let { data, status, message } = await updateSettlementAccount4({
          consignorName: this.searchForm.consignorName,
          supplierName: this.searchForm.supplierName,
          standingBookMonth: this.searchForm.standingBookMonthStr,
          typeStrs: this.searchForm.typeStrs,
          frameNumber: this.searchForm.frameNumber,
        });
        this.loading = false;
        if (status !== 0) return this.$message.warning(message);
        // 表格刷新
        await this.getTableData();
      },
      async secondEstimatedPriceRefreshBtn() {
        if (!this.searchForm.typeStrs) return this.$message.warning('费用类型不能为空');
        this.loading = true;
        let { data, status, message } = await updateSettlementAccount3({
          consignorName: this.searchForm.consignorName,
          supplierName: this.searchForm.supplierName,
          standingBookMonth: this.searchForm.standingBookMonthStr,
          typeStrs: this.searchForm.typeStrs,
          frameNumber: this.searchForm.frameNumber,
        });
        this.loading = false;
        if (status !== 0) return this.$message.warning(message);
        // 表格刷新
        await this.getTableData();
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text').replace(/\s/g, ',').split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'frameNumber':
            this.searchForm.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
          case 'standingBookMonthStr':
            this.searchForm.standingBookMonthStr = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
      getType(type) {
        switch (type) {
          case 0:
            return '收入';
          case 1:
            return '公路运费';
          case 2:
            return '水路运费';
          case 3:
            return '装船费';
          case 4:
            return '卸船费';
          case 5:
            return '过驳费';
          case 6:
            return '转船费';
          case 7:
            return '堆存费';
          case 8:
            return '提车费';
          default:
            return '--';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.submitType = '';
        this.searchForm.submitType1 = '';
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 刷新台账
      async refreshAccount() {
        this.loading = true;
        const { status, message } = await refreshAccountList();
        this.loading = false;
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        //await this.resetBtn();
        // await this.getTableData();
      },
      // 生成台账
      generateAccount() {
        let flag = false;
        for (let searchFormKey in this.searchForm) {
          if (searchFormKey === 'page' || searchFormKey === 'rows') continue;
          if (this.searchForm[searchFormKey] !== '') {
            flag = true;
          }
        }
        if (!flag) return this.$message.warning('请输入查询条件后生成台账！');
        this.$confirm('确认是否生成台账？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          this.loading = true;
          const { status, message } = await generateAccount({
            ...this.searchForm,
            carList: this.searchForm.frameNumber.length > 0 ? this.searchForm.frameNumber.split(',') : [],
            deliveryDateStart: this.searchForm.delivery[0],
            deliveryDateEnd: this.searchForm.delivery[1],
          });
          this.loading = false;
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.searchBtn();
        });
      },
      reconciliationAdjustmentGenerationLedger() {
        this.flag1 = 2;
        this.dialogAccoutVisible = true;
      },
      // 提交调账
      submitReconciliation() {
        this.flag1 = 1;
        // if (this.$refs.registerTable.selection.length === 0) return this.$message.warning('请选择数据后提交调账');
        // const childIds = [],
        //   tipStrArr = [];
        // let tipFlag = true,
        //   tipStr = '';
        // this.$refs.registerTable.selection.forEach((item, index) => {
        //   if (item.taxPriceDiffer === null || item.zxPriceDiffer === null || item.taxPriceDiffer2 === null) {
        //     tipFlag = false;
        //     tipStrArr.push(item.frameNumber);
        //   }
        //   childIds.push(item.id);
        // });
        // if (tipFlag) {
        //   this.$refs.accountAndReconciliation.dialogOpen({
        //     name: '提交调账',
        //     ids: childIds,
        //   });
        // } else {
        //   tipStrArr.forEach((item, index) => {
        //     if (index + 1 === tipStrArr.length) {
        //       tipStr += item;
        //     } else {
        //       (index + 1) % 2 === 0 ? tipStr += item + ',' : tipStr += item + ',\n';
        //     }
        //     console.log(tipStr, index, tipStrArr.length);
        //   });
        //   return this.$message.warning('车架号：' + tipStr + '收入运费或收入装卸费或支出费用 差额为空无法提交调账');
        // }
        this.dialogAccoutVisible = true;
      },
      //确认
      async submit() {
        this.submitLoading = true;
        try {
          if (this.flag1 == 1) {
            const { status, message } = await generateAccountByDifferenceBatch({ ...this.searchForm,submitType: this.radio });
            if (status !== 0) {
              this.$message.warning(message);
              this.submitLoading = false;
              return;
            }
            this.$message.success(message);
            this.submitLoading = false;
            this.dialogAccoutClose();
          } else {
            const { status, message } = await generateAccountByDifferenceBatch2({ ...this.searchForm,submitType1: this.radio });
            if (status !== 0) {
              this.$message.warning(message);
              this.submitLoading = false;
              return;
            }
            this.$message.success(message);
            this.submitLoading = false;
            this.dialogAccoutClose();
          }

        } catch (error) {
          this.$message.error(error);
          this.submitLoading = false;
        }
      },
      //取消
      cancel() {
        this.dialogAccoutVisible = false;
      },
      dialogAccoutClose() {
        this.radio = ''
        this.dialogAccoutVisible = false;
      },

      //提交对账
      submitBtn(row) {
        this.dialogVisible = true;
        this.searchForm.parentId = row.parentId;
        this.searchForm.id = row.id;
      },
      //支出
      async disburseClick() {
        const { status, message } = await generateAccountByDifference({
          id: this.searchForm.id,
        });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.$emit('getTableData');
        this.dialogClose();
      },
      //收入
      async incomeClick() {
        const { status, message } = await generateAccountByDifference({
          parentId: this.searchForm.parentId,
        });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.$emit('getTableData');
        this.dialogClose();
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      handleRowClick() {},
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const { data, status, message } = await getAccountList({
          ...this.searchForm,
          carList: this.searchForm.frameNumber.length > 0 ? this.searchForm.frameNumber.split(',') : [],
          startDate: this.searchForm.dealer[0],
          endDate: this.searchForm.dealer[1],
          deliveryDateStart: this.searchForm.delivery[0],
          deliveryDateEnd: this.searchForm.delivery[1],
        });
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.message = message;
        this.total = data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      selectionDataChange(selection) {
        this.checkTableData = selection;
      },
      rowStyle({ row }) {
        // console.log(row);
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : row.isOffset == 1?{ background: 'rgb(178,209,255)' }:{};
      },
      // 合并相同列
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        // data ：需要修改的列数和列的属性 第一列从0开始
        // const data = [
        //   {
        //     columnIndex: 1,
        //     value: 'consignorName',
        //   },
        //   {
        //     columnIndex: 2,
        //     value: 'standingBookMonth',
        //   },
        //   {
        //     columnIndex: 3,
        //     value: 'waybillNo',
        //   },
        //   {
        //     columnIndex: 4,
        //     value: 'frameNumber',
        //   },
        //   {
        //     columnIndex: 5,
        //     value: 'brandName',
        //   },
        //   {
        //     columnIndex: 6,
        //     value: 'modelName',
        //   },
        //   {
        //     columnIndex: 7,
        //     value: 'departurePlace',
        //   },
        //   {
        //     columnIndex: 8,
        //     value: 'departurePort',
        //   },
        //   {
        //     columnIndex: 9,
        //     value: 'arrivePort',
        //   },

        //   {
        //     columnIndex: 10,
        //     value: 'arrivePlace',
        //   },
        //   {
        //     columnIndex: 11,
        //     value: 'plannedDate',
        //   },
        //   {
        //     columnIndex: 12,
        //     value: 'transType',
        //   },
        //   {
        //     columnIndex: 13,
        //     value: 'oilPrice',
        //   },
        //   {
        //     columnIndex: 14,
        //     value: 'taxContractPrice',
        //   },
        //   {
        //     columnIndex: 15,
        //     value: 'taxGlPrice',
        //   },
        //   {
        //     columnIndex: 16,
        //     value: 'taxSlPrice',
        //   },
        //   {
        //     columnIndex: 17,
        //     value: 'taxMdglPrice',
        //   },
        //   {
        //     columnIndex: 18,
        //     value: 'freightSettNo',
        //   },
        //   {
        //     columnIndex: 19,
        //     value: 'taxActualPrice',
        //   },
        //   {
        //     columnIndex: 20,
        //     value: 'actualSettType',
        //   },
        //   {
        //     columnIndex: 21,
        //     value: 'taxPriceDiffer',
        //   },
        //   {
        //     columnIndex: 22,
        //     value: 'operationSettNo',
        //   },
        //   {
        //     columnIndex: 23,
        //     value: 'taxZxPrice',
        //   },
        //   {
        //     columnIndex: 24,
        //     value: 'zxActualPrice',
        //   },
        //   {
        //     columnIndex: 25,
        //     value: 'zxPriceDiffer',
        //   },
        //   {
        //     columnIndex: 26,
        //     value: 'zxActualPrice',
        //   },
        //   {
        //     columnIndex: 27,
        //     value: 'zxPriceDiffer',
        //   },
        //   {
        //     columnIndex: 28,
        //     value: 'tztzbatch',
        //   },
        // ];
        const data = [
          {
            columnIndex: 1,
            value: 'consignorName',
          },
          {
            columnIndex: 2,
            value: 'standingBookMonth',
          },
          {
            columnIndex: 3,
            value: 'waybillNo',
          },
          {
            columnIndex: 4,
            value: 'frameNumber',
          },
          {
            columnIndex: 5,
            value: 'brandName',
          },
          {
            columnIndex: 6,
            value: 'modelName',
          },
          {
            columnIndex: 7,
            value: 'departurePlace',
          },
          {
            columnIndex: 8,
            value: 'departurePort',
          },
          {
            columnIndex: 9,
            value: 'arrivePort',
          },
          {
            columnIndex: 10,
            value: 'arrivePlace',
          },
          {
            columnIndex: 11,
            value: 'plannedDate',
          },
          {
            columnIndex: 12,
            value: 'deliveryDate1',
          },
          {
            columnIndex: 13,
            value: 'transType',
          },
          {
            columnIndex: 14,
            value: 'oilPrice',
          },
          {
            columnIndex: 15,
            value: 'taxContractPrice',
          },
          {
            columnIndex: 16,
            value: 'taxContractPriceDif2',
          },
          {
            columnIndex: 17,
            value: 'taxContractPriceDif3',
          },
          {
            columnIndex: 18,
            value: 'taxAdjustPrice',
          },
          {
            columnIndex: 19,
            value: 'taxGlPrice',
          },
          {
            columnIndex: 20,
            value: 'taxSlPrice',
          },
          {
            columnIndex: 21,
            value: 'taxMdglPrice',
          },
          {
            columnIndex: 22,
            value: 'freightSettNo',
          },
          {
            columnIndex: 23,
            value: 'ryjsbatch',
          },
          {
            columnIndex: 24,
            value: 'taxActualPrice',
          },
          {
            columnIndex: 25,
            value: 'actualSettType',
          },
          {
            columnIndex: 26,
            value: 'taxPriceDiffer',
          },
          {
            columnIndex: 27,
            value: 'taxZxPrice',
          },
          {
            columnIndex: 28,
            value: 'operationSettNo',
          },
          {
            columnIndex: 29,
            value: 'zxActualPrice',
          },
          {
            columnIndex: 30,
            value: 'zxPriceDiffer',
          },
          {
            columnIndex: 31,
            value: 'TZTZBatch',
          },
          {
            columnIndex: 32,
            value: 'isOffset2',
          },
        ];
        for (let index = 0; index < data.length; index++) {
          if (columnIndex === data[index].columnIndex) {
            const _row = this.filterData(this.tableData, data[index].value)[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
              rowspan: _row,
              colspan: _col,
            };
          }
        }
      },
      // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
      filterData(arr, value) {
        let spanOneArr = [];
        let concatOne = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            // name 修改
            if (item[value] === arr[index - 1][value]) {
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
        return spanOneArr;
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        this.loading = true;
        window.exportExcel(`${baseUrl}/platform/settlement/account/exportXls1?access_token=${token}`, {
          // waybillNo: this.searchForm.waybillNo,
          // carList: this.searchForm.frameNumber.length > 0 ? this.searchForm.frameNumber.split(',') : [],
          // consignorName: this.searchForm.consignorName,
          // supplierName: this.searchForm.supplierName,
          // standingBookMonthStr: this.searchForm.standingBookMonthStr,
          // isAccount: this.searchForm.isAccount,
          // isAdjust: this.searchForm.isAdjust,
          // settType: this.searchForm.settType,
          // brandName: this.searchForm.brandName,
          // typeStrs: this.searchForm.typeStrs,
          // isContactPrice: this.searchForm.isContactPrice,
          // frameNumber: this.searchForm.frameNumber,
          ...this.searchForm,
          carList: this.searchForm.frameNumber.length > 0 ? this.searchForm.frameNumber.split(',') : [],
          startDate: this.searchForm.dealer[0],
          endDate: this.searchForm.dealer[1],
          deliveryDateStart: this.searchForm.delivery[0],
          deliveryDateEnd: this.searchForm.delivery[1],
        }, '台账明细', ()=> { this.loading = false; })

        // fetch(`${baseUrl}/platform/settlement/account/exportXls1?access_token=${token}`, {
        //   method: 'POST',
        //   body: JSON.stringify({
        //     // waybillNo: this.searchForm.waybillNo,
        //     // carList: this.searchForm.frameNumber.length > 0 ? this.searchForm.frameNumber.split(',') : [],
        //     // consignorName: this.searchForm.consignorName,
        //     // supplierName: this.searchForm.supplierName,
        //     // standingBookMonthStr: this.searchForm.standingBookMonthStr,
        //     // isAccount: this.searchForm.isAccount,
        //     // isAdjust: this.searchForm.isAdjust,
        //     // settType: this.searchForm.settType,
        //     // brandName: this.searchForm.brandName,
        //     // typeStrs: this.searchForm.typeStrs,
        //     // isContactPrice: this.searchForm.isContactPrice,
        //     // frameNumber: this.searchForm.frameNumber,
        //     ...this.searchForm,
        //     carList: this.searchForm.frameNumber.length > 0 ? this.searchForm.frameNumber.split(',') : [],
        //     startDate: this.searchForm.dealer[0],
        //     endDate: this.searchForm.dealer[1],
        //     deliveryDateStart: this.searchForm.delivery[0],
        //     deliveryDateEnd: this.searchForm.delivery[1],
        //   }), // 这里放请求数据

        //   headers: {
        //     'Content-Type': 'application/json',
        //     Authorization: token,
        //   },
        //   timeout: 5 * 60 * 1000,
        // })
        //   .then(res => {
        //     this.loading = false;
        //     return res.blob();
        //   })
        //   .then(response => {
        //     const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); // 导出.xlsx结尾的文件
        //     const a = document.createElement('a');
        //     a.href = window.URL.createObjectURL(blob);
        //     a.download = '台账明细' + '.xls';
        //     a.click();
        //   });
      },
      // 计划开始-结束日期验证
      dateChange1(val) {
        if (this.searchForm.dealer[1] && this.searchForm.dealer[0] && this.searchForm.dealer[1] <= this.searchForm.dealer[0]) {
          if (val == this.searchForm.dealer[1]) this.searchForm.dealer[1] = '';
          if (val == this.searchForm.dealer[0]) this.searchForm.dealer[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      // 交车开始-结束日期验证
      dateChange2(val) {
        if (this.searchForm.delivery[1] && this.searchForm.delivery[0] && this.searchForm.delivery[1] <= this.searchForm.delivery[0]) {
          if (val == this.searchForm.delivery[1]) this.searchForm.delivery[1] = '';
          if (val == this.searchForm.delivery[0]) this.searchForm.delivery[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },

      // 价格刷新
      async priceRefreshBtn() {
        if (!this.searchForm.typeStrs) return this.$message.warning('费用类型不能为空');
        this.loading = true;
        let { data, status, message } = await getPriceRefresh({
          typeStrs: this.searchForm.typeStrs,
          frameNumber: this.searchForm.frameNumber,
        });
        this.loading = false;
        if (status !== 0) return this.$message.warning(message);
        // 表格刷新
        await this.getTableData();
      },
      // 实际结算价格刷新
      async refreshActualSettlementPrice() {
        if (!this.searchForm.typeStrs) return this.$message.warning('费用类型不能为空');
        this.loading = true;
        let { data, status, message } = await refreshActualSettlementPrice({
          ...this.searchForm,
        });
        this.loading = false;
        if (status !== 0) return this.$message.warning(message);
        // 表格刷新
        await this.getTableData();
      },
      async correctionAndAdjustment() {
        if (this.searchForm.frameNumber === '') return this.$message.warning('请输入车架号后纠错调账！');
        this.$refs.correctionAndAdjustmentRef.dialogOpen(this.searchForm);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }

        .el-select__tags {
          max-width: 100% !important;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }
            }
          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }
    }
  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
